import api from "shared/api";
import { ManualRaw } from "./models";
import { AxiosPromise } from "axios";

const prefix = "api/manuals";

export interface PostManualRequest {
  name: string;
  description: string;
  tags: string[] | null;
}
interface PostManualResponse {
  id: number;
}

export const getManuals = async (): Promise<ManualRaw[]> => {
  try {
    const res = await api().get<ManualRaw[]>(`${prefix}/list`);
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getBlob = async (url: string): Promise<Blob> => {
  try {
    const res = await api().get<Blob>(url, { responseType: "blob" });
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const getNonCachedBlob = async (url: string): Promise<Blob> => {
  url += "?ts=" + new Date().getTime();
  return getBlob(url);
};

export const postManual = async (
  payload: PostManualRequest
): Promise<number> => {
  try {
    const res = await api().post<PostManualResponse>(`${prefix}/new`, payload);
    return res.data.id;
  } catch (e) {
    throw e;
  }
};

export const postThumbnail = async (id: number, file: File): Promise<void> => {
  try {
    const formData = new FormData();
    formData.append("thumbnail", file);

    await api().post(`${prefix}/${id}/thumbnail`, formData, {
      headers: { "content-type": "multipart/form-data" }
    });
  } catch (e) {
    throw e;
  }
};

export const postPdf = async (id: number, file: File): Promise<void> => {
  try {
    const formData = new FormData();
    formData.append("pdf", file);

    api().post(`${prefix}/${id}/pdf`, formData, {
      headers: { "content-type": "multipart/form-data" }
    });
  } catch (e) {
    throw e;
  }
};

export const putManual = async (
  id: number,
  payload: PostManualRequest
): Promise<number> => {
  try {
    const res = await api().put<PostManualResponse>(`${prefix}/${id}`, payload);
    return res.data.id;
  } catch (e) {
    throw e;
  }
};

export const deleteManual = (id: number): AxiosPromise => {
  return api().delete(`${prefix}/${id}`);
};
